import styled from "styled-components";

export const PostContainer = styled.div<{ onClick: () => void }>`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 140px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #f5f5f5;
  
  &:hover {
    &::after {
      opacity: 1;
    }
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, transparent 50%, #fe2f67);
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
  }

  &:nth-child(5) {
    aspect-ratio: 3/1;
  }
`;

export const PostImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

